import React from 'react'

function Homepage() {
    return (
        <div className='container text-center d-flex justify-content-center align-items-center' style={{ height: '80vh' }}>
            <h1>Welcome To E-commerce</h1>
        </div>
    )
}

export default Homepage
